<template>
  <owal-transition-fade>
    <owal-banner
      slot="content"
      class="owal-loading__banner"
      :class="{collapsed}"
      style="flex-direction: row;"
      @click.native="collapsed = !collapsed"
    >
      <div
        class="owal-loading__spinner"
      >
        <owal-spinner-logo
          class="owal-loading__logo"
        />
      </div>
      <div
        class="owal-loading__text"
      >
        <div
          class="owal-loading__primary"
        >
          {{ title }}
        </div>
        <slot
          class="owal-loading__secondary"
          name="subtitle"
        >
          {{ subtitle }}
        </slot>
      </div>
    </owal-banner>
  </owal-transition-fade>
</template>

<script>
import {
  OwalBanner,
  OwalSpinnerLogo,
  OwalTransitionFade,
} from '@/libraries/owal-ui'

export default {
  name: 'OwalLoadingBanner',
  components: {
    OwalBanner,
    OwalSpinnerLogo,
    OwalTransitionFade,
  },
  props: {
    title: {
      type: String,
      default: 'Loading',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      collapsed: true,
    }
  },
  watch: {
    humanReadableRefreshState: {
      deep: true,
    },
  },
}
</script>

<style scoped>
.owal-loading__banner {
  position: fixed;
  top: 3.5rem;
  right: 2rem;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 0.5rem 2rem;
  border: 1px solid #000;
  transition: transform 300ms ease;
}

.owal-loading__banner:hover {
  cursor: pointer;
}

.collapsed {
  transform: translateX(97%);
}

.collapsed .owal-loading__text {
  height: 1rem;
}

.owal-loading__spinner {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;
  height: fit-content;
  margin: 0;
  padding: 0;
}

.owal-loading__logo {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  border-radius: 50%;
  cursor: pointer;
  transition: background 200ms ease, margin 200ms ease, height 300ms ease,
    width 300ms ease;
}

.owal-loading__banner .owal-loading__logo {
  height: 5rem;
  width: 5rem;
  margin: 1rem;
}

.collapsed .owal-loading__logo {
  height: 1.5rem;
  width: 1.5rem;
  margin: 1rem 0 1rem 0.5rem;
}

.owal-loading__logo:hover {
  border-radius: 50%;
  background: #00000011;
}

.owal-loading__text {
  transition: opacity 200ms ease;
}

.owal-loading__banner .owal-loading__text {
  opacity: 1;
}

.collapsed .owal-loading__text {
  opacity: 0;
}

.owal-loading__primary {
  display: flex;
  flex-direction: row;
  font-weight: bold;
  padding: 0 2rem 0 0;
  font-size: 3rem;
  height: fit-content;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  text-align: left;
  height: 3rem;
}

.owal-loading__secondary {
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: fit-content;
  width: 100%;
  padding-left: 2rem;
  margin-top: -1rem;
  margin-bottom: 1rem;
}
</style>
